module.exports = __webpack_public_path__ + "static/img/l-1.bfd9780.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/l-1.png
// module id = h50F
// module chunks = 0